module.exports = __webpack_public_path__ + "static/media/alis03.5f5ccbe5.jpg";